module.exports = __webpack_public_path__ + "img/logo.594a5c90.png";